(() => {
  const cardFunction = () => {
    const more = qsa('.js-gaspi-card__more');
    const less = qsa('.js-gaspi-card__less');
    const header = qs('.js-header-sticky');
    const seeMore = qsa('.js-anti-gaspi__see-more');
    const activeClass = 'gaspi-card--open-active';
    const seeMoreActive = 'anti-gaspi__see-more--active';
    let top = 0;

    if(seeMore) {
      seeMore.forEach(see => {
        see.addEventListener('click', e => {
          e.preventDefault();
          const current = e.currentTarget;
          const currentParent = getClosest('.js-anti-gaspi__list', current);
          const articles_hidden = qsa('.js-anti-gaspi__item--hidden', currentParent);
          if(current.classList.contains(seeMoreActive)) {
            current.classList.remove(seeMoreActive)
            if(articles_hidden) {
              articles_hidden.forEach(item => {
                item.removeAttribute('style');
              })
            }
            qs('.anti-gaspi__see-more-text', e.currentTarget).style.display = 'inline-block';
            qs('.anti-gaspi__see-less-text', e.currentTarget).style.display = 'none';
          } else {
            current.classList.add(seeMoreActive)
            if(articles_hidden) {
              articles_hidden.forEach(item => {
                item.style.display = 'block';
              })
            }
            qs('.anti-gaspi__see-more-text', e.currentTarget).style.display = 'none';
            qs('.anti-gaspi__see-less-text', e.currentTarget).style.display = 'inline-block';
          }
        })
      });
    }

    if(more) {
      more.forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = getClosest('.js-gaspi-card-wrap', e.currentTarget);
          const contentDefault = qs('.gaspi-card--default', parent);
          const content = qs('.js-gaspi-card-open', parent);
          const contentTop = content.getBoundingClientRect().top;
          const contentInner = qs('.js-gaspi-card-open__inner', parent);

          if(header) {
            top = (contentTop + window.scrollY) - (header.getBoundingClientRect().height + contentDefault.getBoundingClientRect().height);
          } else {
            top = (contentTop + window.scrollY) - contentDefault.getBoundingClientRect().height;
          }

          if(content) {
            if(!content.classList.contains(activeClass)) {
              content.classList.add(activeClass);
              content.style.maxHeight = `${contentInner.getBoundingClientRect().height + 36}px`;
              
              setTimeout(() => {
                window.scrollTo({top: top});
                contentDefault.style.display = 'none';
              });
            } 
          }
        })
      });
    }

    if(less) {
      less.forEach(el => {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = getClosest('.js-gaspi-card-wrap', e.currentTarget);
          const contentDefault = qs('.gaspi-card--default', parent);
          const content = qs('.js-gaspi-card-open', parent);
          let top = 0;

          if(content) {
            contentDefault.style.display = 'block';
            const contentDefaultTop = contentDefault.getBoundingClientRect().top;
            setTimeout(() => {
              if(header) {
                top = (contentDefaultTop + window.scrollY) - (header.getBoundingClientRect().height);
              } else {
                top = (contentDefaultTop + window.scrollY);
              }
              
              window.scrollTo({top: top});

              setTimeout(() => {
                content.classList.remove(activeClass);
                content.style.maxHeight = 0;
              });
            });
          }
        })
      });
    }
  };

  function filterTabs() {
    new Swiper('.js-anti-gaspi-tabs-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      init: true,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      watchOverflow: true,
      breakpoints: {
        990: {
          spaceBetween: 0
        }
      },
      navigation: {
        nextEl: '.js-anti-gaspi__swiper-next',
        prevEl: '.js-anti-gaspi__swiper-prev',
      }
    });

    const tabs = qsa('.js-anti-gaspi__tab');
    const filterContent = qsa('.js-anti-gaspi__list');
    const filterActiveClass = 'anti-gaspi__tab--active';
    const path = window.location.pathname;
    const tag = path.split('/tagged/')[1];
    const contentTabs = qs('#js-tabs');
    const header = qs('.js-header-sticky');
    if(tabs) {
      tabs.forEach(tab => {
        const href = decodeURI(tab.getAttribute('href')).toLowerCase();
        const shouldMatch = tag ? href.includes(tag) || href === window.location.pathname : href === window.location.pathname;
        if(shouldMatch) {
          const targetContent = getClosest('.anti-gaspi__tab-item', tab);
          const targetData = targetContent.dataset.target;
            if(targetData) {
              const targetEl = document.getElementsByClassName(`${targetData}`);
              if(filterContent) {
                filterContent.forEach(item => {
                  item.style.display = 'none';
                })
              }
              tabs.forEach(tab => {
                tab.classList.remove(filterActiveClass);
              });
              targetEl[0].style.display = 'block';
              tab.classList.add(filterActiveClass);
            }

          const headerHeight = header && header.getBoundingClientRect().height || 0
          const contentTop = contentTabs.getBoundingClientRect().top - headerHeight;
          setTimeout(() => {
            window.scrollTo({ top: contentTop });
          })
        } 

        // tab.addEventListener('click', e => {
        //   e.preventDefault();
        //   console.log(e);
        //   const targetContent = getClosest('.anti-gaspi__tab-item', e.target);
        //   const targetData = targetContent.dataset.target;
        //   if(targetData) {
        //     const targetEl = document.getElementsByClassName(`${targetData}`);
        //     if(filterContent) {
        //       filterContent.forEach(item => {
        //         item.style.display = 'none';
        //       })
        //     }
        //     tabs.forEach(tab => {
        //       tab.classList.remove(filterActiveClass);
        //     });
        //     targetEl[0].style.display = 'block';
        //     e.target.classList.add(filterActiveClass);
        //   }
        // })
      })
    }
  };

  cardFunction();
  filterTabs();
  document.addEventListener('shopify:section:load', () => {
    cardFunction();
    //filterTabs();
  });
})();
